import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/common/icon-arrow-left.svg'
import _imports_1 from '@/assets/img/common/img-pagetop.svg'


const _withScopeId = n => (_pushScopeId("data-v-6b61374c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "l-wrapper",
  style: {"background-color":"#F3F3F3"}
}
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { class: "p-video --no-pt-sp" }
const _hoisted_4 = { class: "p-video-inner" }
const _hoisted_5 = { class: "p-video-knowhow" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "戻る",
  width: "24",
  height: "24"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "転職活動ノウハウ動画", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "p-video-knowhow__card" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "p-video-knowhow__body" }
const _hoisted_12 = {
  key: 0,
  class: "p-video-knowhow__text line-break"
}
const _hoisted_13 = { class: "p-video-knowhow__block" }
const _hoisted_14 = { class: "p-video-knowhow__text line-break" }
const _hoisted_15 = { class: "l-wrapper_nav" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_18 = [
  _hoisted_17
]

import { getVideoKnowHowDetailService, KnowHowDetailResponse } from '@/api/services/mstMypageVideoKnowHowService';
import { isNumber } from 'lodash';
import { onMounted, ref } from 'vue';
import { RouterLink, useRoute, useRouter } from 'vue-router';
import { domHelperUtils } from '@/utils/domHelper';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoDetailView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const videoData = ref<KnowHowDetailResponse>({});

function scrollToTop() {
  domHelperUtils.scrollToTop();
}

onMounted(async () => {
  const knowhowId = Number(route.params.knowhowId);

  if (knowhowId && isNumber(knowhowId)) {
    const resp = await getVideoKnowHowDetailService(knowhowId);
    if (resp) {
      videoData.value = resp;
    } else {
      router.push({name: 'p00'});
    }
  }
});

function handleBack() {
  window.history.back();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", {
              class: "p-video-back",
              onClick: handleBack
            }, _hoisted_8),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: "p-video-knowhow__video",
                innerHTML: videoData.value.knowhowUrlVideoMypageTag
              }, null, 8, _hoisted_10),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h1", {
                  class: _normalizeClass(["p-video-knowhow__title", {'explanation-empty': !videoData.value.explanation?.trim()}])
                }, _toDisplayString(videoData.value.title), 3),
                (videoData.value.explanation?.trim())
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(videoData.value.explanation), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("p", _hoisted_14, _toDisplayString(videoData.value.explanationDetail), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("a", {
        class: "g-pagetop",
        href: "#",
        onClick: _withModifiers(scrollToTop, ["prevent"]),
        "aria-label": "ページトップへ戻る"
      }, _hoisted_18, 8, _hoisted_16)
    ])
  ]))
}
}

})